<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">

  <!-- Header -->
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{"FIRMWARE_UPDATE" | translate}}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tabs">
    <ul>
      <li [class.active]="activeTab === 'update'" (click)="activeTab = 'update'; showSchedulePanel = false">
        {{"UPDATE" | translate}}
      </li>
      <li [class.active]="activeTab === 'scheduled'" (click)="selectScheduledTab()">
        {{"SCHEDULED" | translate}}
      </li>
    </ul>
  </div>

  <!-- UPDATE TAB -->
  @if (activeTab === 'update') {
  <div class="row g-0 m-0 body p-3 pt-2 first-section">

    <!-- Selected meters group -->
    @if (activeMeters.length > 0) {
    <div class="section-card mb-3">
      <div class="selected-count mb-2">
        <span class="item-name">{{activeMeters.length}} {{"SELECTED_METERS" | translate}}</span>
      </div>
      <div class="selected-meters-wrap">
        @for (meter of activeMeters; track meter.id) {
        <span class="meter-chip">
          <span class="chip-type-pill">{{meter.assetTypeName}}</span>
          <span class="chip-meter-pill">
            <svg-icon class="chip-orbit-icon" src="assets/device/meter-orbit.svg"></svg-icon>
            <span class="chip-no">{{meter.meterNo}}</span>
          </span>
          <span class="chip-remove" (click)="deselectMeter(meter)">×</span>
        </span>
        }
      </div>
    </div>
    }

    <!-- Firmware version + Maximum attempts group -->
    <div class="section-card">
      <!-- Firmware version dropdown -->
      <div class="form-item">
        <div class="form-label-div">
          <label class="form-label">{{"FIRMWAREVERSION" | translate}}</label>
        </div>
        <div class="form-input">
          <div class="form-input-div">
            <select [(ngModel)]="selectedId" [disabled]="safeTargetMeterModels.length === 0">
              <option value="" disabled selected>{{"SELECT_VERSION" | translate}}</option>
              @for (item of safeTargetMeterModels; track item.value) {
              <option [value]="item.value">{{item.name}}</option>
              }
            </select>
          </div>
          @if (safeTargetMeterModels.length === 0) {
          <div class="validation-error">{{"FIRMWARE_UPDATENOMODELS" | translate}}</div>
          }
        </div>
      </div>

      <!-- Maximum attempts -->
      <div class="form-item">
        <div class="form-label-div">
          <label class="form-label">{{"FIRMWARE_UPDATE_RETRY" | translate}}</label>
        </div>
        <div class="form-input">
          <div class="form-input-div attempts-row">
            <input type="number" step="1" min="1" max="10" required [(ngModel)]="maxRetries" #retryInput="ngModel" />
            <button class="attempt-btn" (click)="decrement()">−</button>
            <button class="attempt-btn" (click)="increment()">+</button>
            <button class="attempt-btn clear-btn" (click)="clearRetries()">
              {{"CLEAR" | translate}}
            </button>
          </div>
          @if (maxRetries < 1 || maxRetries> 10) {
            <div class="validation-error">{{"FIRMWARE_UPDATE_RETRYERROR" | translate}}</div>
            }
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="row g-0 m-0 p-3 mt-auto" [class.bordert]="!showSchedulePanel">
    @if (showSchedulePanel) {
    <div class="schedule-panel">
      <span class="schedule-panel-label">{{"SCHEDULE_UPDATE_FOR_LATER" | translate}}</span>
      <div class="schedule-fields">
        <app-date-picker class="date-picker-wrap" [(value)]="scheduledDate"
          [placeholder]="'FIRMWARE_SCHEDULE_DATE' | translate"
          [disablePastDates]="true">
        </app-date-picker>
        <app-time-picker class="time-picker-wrap" [(value)]="scheduledTime"
          [placeholder]="'FIRMWARE_SCHEDULE_TIME' | translate"
          [disablePastTimes]="true"
          [minDate]="scheduledDate">
        </app-time-picker>
      </div>
    </div>
    }
    <div class="col-12 d-flex justify-content-between align-items-center">
      <span class="close-link cursor-pointer" (click)="toggleModal()">{{"CLOSE_WINDOW" | translate}}</span>
      <div class="d-flex gap-2 align-items-center">
        @if (showSchedulePanel) {
        <button class="attempt-btn clear-btn" (click)="showSchedulePanel = false">
          {{"CANCEL" | translate}}
        </button>
        <div class="btn-group-update">
          <div class="btn-update-now" [ngClass]="{'disabled': !canSchedule}"
            (click)="canSchedule ? scheduleUpdate() : null">
            <span>{{"SCHEDULE_NOW" | translate}}</span>
          </div>
        </div>
        } @else {
        <div class="btn-group-update">
          <div class="btn-update-now" [ngClass]="{'disabled': !canUpdate}" (click)="canUpdate ? continue() : null">
            <span>{{"UPDATE_NOW" | translate}}</span>
          </div>
          <div class="btn-clock" (click)="showSchedulePanel = true">
            <svg-icon src="assets/device/hour.svg"></svg-icon>
            <svg-icon src="assets/device/chevron-down.svg" class="btn-clock-chevron"></svg-icon>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }

  <!-- SCHEDULED TAB -->
  @if (activeTab === 'scheduled') {
  <div class="row g-0 m-0 body p-3 pt-2 first-section">
    @if (scheduledGroups.length === 0) {
    <div class="empty-scheduled d-flex justify-content-center align-items-center">
      <span class="validation-instruction">{{"NO_SCHEDULED_UPDATES" | translate}}</span>
    </div>
    }
    @for (group of scheduledGroups; track group.scheduledTime) {
    <div class="section-card schedule-group mb-3">
      <div class="group-header d-flex justify-content-between align-items-center mb-3">
        <span class="group-date">{{getDatePrefix(group.scheduledTime)}}{{group.scheduledTime | date:'d MMM y, h:mm a':timezoneOffset}}</span>
        <span class="remove-batch cursor-pointer" (click)="removeBatch(group)">
          {{"REMOVE_BATCH" | translate}}
        </span>
      </div>
      @for (item of group.commands; track item.id; let last = $last) {
      <div class="schedule-item d-flex align-items-start">
        <div class="timeline-icon-wrap me-3">
          <div class="status-icon">
            @if (item.status === CommandStatus.Pending || item.status === CommandStatus.Scheduled) {
            <svg-icon src="assets/device/hour.svg" class="icon-pending"></svg-icon>
            } @else if (item.status === CommandStatus.Failed) {
            <svg-icon src="assets/device/firmware-update-failed.svg" class="icon-failed"></svg-icon>
            } @else {
            <svg-icon src="assets/device/firmware-update-success.svg" class="icon-success"></svg-icon>
            }
          </div>
        </div>
        <div class="item-details flex-grow-1" [class.mb-3]="!last">
          <div class="d-flex justify-content-between align-items-center">
            <span class="item-name">{{item.meter.assetType}}</span>
            @if (item.status === CommandStatus.Scheduled) {
            <div class="d-flex gap-2 align-items-center">
              <div class="action-btn cursor-pointer d-flex align-items-center p-1" (click)="deleteItem(item)">
                <svg-icon src="assets/core/table/delete.svg"></svg-icon>
              </div>
            </div>
            }
          </div>
          <div class="item-sub">MN {{item.meter.meterNumber}} · {{item.meter.meterType}}</div>
        </div>
      </div>
      }
    </div>
    }
  </div>
  <div class="row g-0 m-0 p-3 bordert mt-auto">
    <div class="col-12 d-flex justify-content-between align-items-center p-2">
      <span class="close-link cursor-pointer" (click)="toggleModal()">{{"CLOSE_WINDOW" | translate}}</span>
    </div>
  </div>
  }

</div>